var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DropdownContainer, DropdownLabel } from './styles';
import SearchableSelect from '../Common/SearchableSelect/SearchableSelect';
var FilterDropdown = function (_a) {
    var label = _a.label, width = _a.width, rest = __rest(_a, ["label", "width"]);
    return (React.createElement(DropdownContainer, { style: {
            width: width,
        } },
        React.createElement(DropdownLabel, null, label),
        React.createElement(SearchableSelect, __assign({}, rest, { outlined: false }))));
};
export default FilterDropdown;
